import { ref, toRef, toValue, watch } from "vue";
import type { Plugin } from "../types";

// support refreshDeps & ready
const useAutoRunPlugin: Plugin<any, any[]> = (
  fetchInstance,
  { manual, ready = ref(true), defaultParams = [], refreshDeps = [], refreshDepsAction }
) => {
  watch(toRef(ready), () => {
    if (!manual && toValue(ready)) {
      fetchInstance.run(...defaultParams);
    }
  });

  watch(refreshDeps, () => {
    if (!manual) {
      if (refreshDepsAction) {
        refreshDepsAction();
      } else {
        fetchInstance.refresh();
      }
    }
  });

  return {
    onBefore: () => {
      if (!ready.value) {
        return {
          stopNow: true
        };
      }
    }
  };
};

useAutoRunPlugin.onInit = ({ ready = ref(true), manual }) => {
  return {
    loading: !manual && ready.value
  };
};

export default useAutoRunPlugin;
